import { render, staticRenderFns } from "./default_detail.vue?vue&type=template&id=f5a148f0&scoped=true&"
import script from "./default_detail.vue?vue&type=script&lang=js&"
export * from "./default_detail.vue?vue&type=script&lang=js&"
import style0 from "./default_detail.vue?vue&type=style&index=0&id=f5a148f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a148f0",
  null
  
)

export default component.exports